import { Button, Col, Form, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import FormItem from '../FormItem/FormItem';

interface ChangePasswordProps {
  isLoading?: boolean;
  onSubmit: (values: unknown) => void;
  okText?: string;
  closable?: boolean;
  cancelText?: string;
  onCancel?: (values?: unknown) => void;
}

const ChangePassword = ({
  isLoading = false,
  onSubmit,
  okText = 'Save',
  closable = true,
  cancelText = 'Cancel',
  onCancel = () => {},
}: ChangePasswordProps) => {
  const { t } = useTranslation('Vindoc');

  const [form] = Form.useForm();
  const password = Form.useWatch('password', form);

  const actionSave = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values);
      })
      .catch((err) => {
        console.error('ChangePassword Failed:', err);
      });
  };

  return (
    <Modal
      open={true}
      maskClosable={false}
      closable={closable}
      onCancel={onCancel}
      centered
      forceRender
      footer={null}
      title={t('Change Password')}
      // width="60%"
      confirmLoading={isLoading}
    >
      <Form form={form} onFinish={actionSave} layout="vertical" name="edit-account">
        <Row gutter={32}>
          <Col xs={24}>
            <FormItem.Password required={true} />
            <FormItem.PasswordConfirm required={true} password={password} />
          </Col>
        </Row>
      </Form>
      <div className="footer mt-3 flex justify-end">
        {closable && (
          <Button className="mr-2" onClick={onCancel}>
            {t(cancelText)}
          </Button>
        )}
        <Button type="primary" onClick={actionSave}>
          {t(okText)}
        </Button>
      </div>
    </Modal>
  );
};

export default ChangePassword;
